<template>
    <div>
        <div class="dataTables_wrapper dt-bootstrap4">
            <div class="row">
                <div class="col-sm-12 overflow-auto">
                    <table id="salesReportDateTable" class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(items, item, j) in commissionItems" :key="j">
                                <td>{{j+1}}</td>
                                <td>{{item}}</td>
                                <td>{{formatPrice(items.service)}}</td>
                                <td>{{formatPrice(items.product)}}</td>
                                <td>{{formatPrice(items.package)}}</td>
                                <td>{{formatPrice(items.discount)}}</td>
                                <td>{{formatPrice(items.outstandings)}}</td>
                                <td>{{formatPrice(items.total)}}</td>
                            </tr>
                            <tr>
                                <td colspan="2" class="border-top-bottom-2 text-right fw-700">{{$t('label.total')}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('service'))}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('product'))}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('package'))}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('discount'))}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('outstandings'))}}</td>
                                <td class="border-top-bottom-2 fw-700">{{formatPrice(getTotal('total'))}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import _ from 'lodash';
import {formatPrice, dateRange, reorderObject, setAYearArr, setYearArr} from './../../../../../assets/js/dashboard/utilities'
import {setSalesCommissionItems} from './../../../../../assets/js/dashboard/salonReport/salonReport'
export default {
    name: "salesDate",
    props:{
        commissionSalesItem: { type: Array }
    },
    data(){
        return{
            commissionItems: {}, objTotal: {},
            isUpdated: false
        }
    },
    computed:{
        fields(){
            return[
                {key: "index", label: "#"},
                {key: "date", label: this.$i18n.t('table.header.date')},
                {key: "service", label: this.$i18n.t('salon_report.item_types.service')},
                {key: "product", label: this.$i18n.t('salon_report.item_types.product')},
                {key: "package", label: this.$i18n.t('salon_report.item_types.package')},
                {key: "discount", label: this.$i18n.t('salon_report.item_types.discount')},
                {key: "outstandings", label: this.$i18n.t('salon_report.item_types.outstandings')},
                {key: "total", label: this.$i18n.t('label.total')},
            ]
        },
    },
    methods:{
        formatPrice(p){
            return formatPrice(p);
        },
        updateTable(items, filter){
            // console.log('filter', filter)
            // startDate: Moment {_isAMomentObject: true, _i: '01/08/2022', _f: 'DD/MM/YYYY', _isUTC: false, _pf: {…}, …}
            // endDate: Moment {_isAMomentObject: true, _i: '31/08/2022', _f: 'DD/MM/YYYY', _isUTC: false, _pf: {…}, …}
            // outlet: "all"
            // type: "" // '', credits, package, all
            // itemType: "outstandings" // all, service, product, package, discount, outstandings
            // voided: "all" // all, shop, online, voided
            // category: "all"
            // folderID: "all"
            // search: ""

            let summary = {
                subTotal: 0,
                totalCredits: 0,
                totalDiscount: 0,
                totalOutstandings: 0,
                totalPackage: 0,
                totalPrice: 0,
                totalSales: 0,
                totalTax: 0,
            }

            let startDate = filter.startDate
            let endDate = filter.endDate
            
            let $vm = this
            const range = dateRange(startDate.toDate(), endDate.toDate())

            let index = 1
            let result = {}
            let lastRow = {
                index: '',
                date: this.$i18n.t('label.total'),
                service: 0,
                product: 0,
                package: 0,
                discount: 0,
                outstandings: 0,
                total: 0,
            }
            range.forEach(date => {
                let dataDate = moment(date).format('YYYYMMDD')
                let resultDate
                
                if(range.length < 365) {
                    resultDate = moment(date).format($vm.$msg.CST.DATE_FORMAT)
                } else if(range.length == 366 || range.length == 365) {
                    resultDate = moment(date).format('MMM YYYY')
                } else {
                    resultDate = moment(date).format('YYYY')
                }

                result[resultDate] = result[resultDate] || {
                    index: index++,
                    date: resultDate,
                    service: 0,
                    product: 0,
                    package: 0,
                    discount: 0,
                    outstandings: 0,
                    total: 0,
                }

                let row = items[dataDate]
                if(row) {
                    for(let type in row) {
                        let resultType = type === 'outstandings' ? type : type.slice(0, -1)

                        if(filter['itemType'] != 'all' && filter['itemType'] !== resultType) {
                            continue
                        }

                        if(filter['voided'] === 'voided') {
                            result[resultDate][resultType] += row[type]['void']
                            result[resultDate]['total'] += row[type]['void']
                            lastRow[resultType] += row[type]['void']
                            lastRow['total'] += row[type]['void']
                            continue
                        }

                        if(filter['type'] === '') {
                            result[resultDate][resultType] += row[type]['sale']
                            result[resultDate]['total'] += row[type]['sale']

                            lastRow[resultType] += row[type]['sale']
                            lastRow['total'] += row[type]['sale']
                        } else if(filter['type'] === 'credits') {
                            result[resultDate][resultType] += row[type]['creditsRedeem']
                            result[resultDate]['total'] += row[type]['creditsRedeem']

                            lastRow[resultType] += row[type]['creditsRedeem']
                            lastRow['total'] += row[type]['creditsRedeem']
                        } else if(filter['type'] === 'package') {
                            result[resultDate][resultType] += row[type]['vouchersRedeem']
                            result[resultDate]['total'] += row[type]['vouchersRedeem']

                            lastRow[resultType] += row[type]['vouchersRedeem']
                            lastRow['total'] += row[type]['vouchersRedeem']
                        } else {
                            result[resultDate][resultType] += row[type]['sale']
                            result[resultDate]['total'] += row[type]['sale']
                            result[resultDate][resultType] += row[type]['creditsRedeem']
                            result[resultDate]['total'] += row[type]['creditsRedeem']
                            result[resultDate][resultType] += row[type]['vouchersRedeem']
                            result[resultDate]['total'] += row[type]['vouchersRedeem']

                            lastRow[resultType] += row[type]['sale']
                            lastRow['total'] += row[type]['sale']
                            lastRow[resultType] += row[type]['creditsRedeem']
                            lastRow['total'] += row[type]['creditsRedeem']
                            lastRow[resultType] += row[type]['vouchersRedeem']
                            lastRow['total'] += row[type]['vouchersRedeem']
                        }

                        summary['totalSales'] += row[type]['sale']
                        summary['subTotal'] += row[type]['sale']
                        summary['totalCredits'] += row[type]['creditsRedeem']
                        summary['subTotal'] += row[type]['creditsRedeem']
                        summary['totalPackage'] += row[type]['vouchersRedeem']
                        summary['subTotal'] += row[type]['vouchersRedeem']
                    }
                }
            })

            this.commissionItems = result

            this.$emit('setTotalData', summary)

            let exportData = Object.keys(result).map(key => result[key])
            exportData.push(lastRow)
            this.$emit('setExportData', { tab: 'date', data: exportData })
        },
        getTotal(type){
            var total = 0;
            for(var key in this.commissionItems){
                var item = this.commissionItems[key]
                for(var itemType in item){
                    if(itemType == type){
                        total += parseFloat(item[itemType].toFixed(2))
                    }
                }
            }
            return total       
        },

    },
}
</script>
<style scoped>
.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
</style>